import React from "react";
import { Link } from "react-router-dom";
import { Glyphicon } from "react-bootstrap";
import MaintenanceAgencyLabel from "../../components/detail/MaintenanceAgencyLabel";

import "./MultiSearchVariableSelectItem.scss";

export const MultiSearchVariableSelectItem = ({
  disabled,
  label,
  description,
  tid,
  type,
  selectedValues,
  onSelect,
  maintenanceAgencyId,
}) => {
  const stopPropagation = (e) => {
    e.stopPropagation(); // we stop bubbling of onClick events up
  };

  const handleClick = () => {
    if (!disabled) {
      onSelect([...selectedValues, tid]);
    }
  };

  return (
    <div
      className={`MultiSearchVariableSelectItem ${
        disabled ? "MultiSearchVariableSelectItem__disabled" : ""
      }`}
      title={`${label}${description ? `\nDescription: ${description}` : " "}`}
      onClick={handleClick}
    >
      <div className="MultiSearchVariableSelectItem__label">{label}</div>
      <div style={{ display: "flex" }}>
        <div className="MultiSearchVariableSelectItem__link">
          <Link
            title={`View this ${type} details in a new tab.`}
            to={`/view/${type}/${tid}`}
            target="_blank"
            onClick={stopPropagation}
          >
            <Glyphicon glyph="new-window" />
          </Link>
        </div>
        <MaintenanceAgencyLabel
          maintenanceAgencyId={maintenanceAgencyId}
        ></MaintenanceAgencyLabel>
      </div>
    </div>
  );
};
